import { createAction } from "redux-act";

export const toggleLoader = createAction<boolean>('toggle loader');
export const fetchNumbers = createAction<string>('fetch available numbers');
export const buyNumber = createAction<{ number: string, navigate: any }>('buy a new number');
export const setNumbers = createAction<any>('set available numbers in list');
